import { NgModule } from '@angular/core';
import { RouterModule, Route, Routes, UrlSegment, UrlSegmentGroup } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { MainComponent } from './components/main/main.component';
import { MapComponent } from './components/map/map.component';

const routes: Routes = [
  {
    path: "",
    component: HomeComponent
  },
  {
    component: MapComponent,
    matcher: (segments: UrlSegment[], group: UrlSegmentGroup, route: Route) => {
      if (segments.length > 0 && segments[0].path === "map") {
        return {
          consumed: segments,
          posParams: {
            param1: new UrlSegment(segments.length > 1 ? segments[1].path : "", {}),
            param2: new UrlSegment(segments.length > 2 ? segments[2].path : "", {})
          }
        }
      }
    }
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {}
